export interface AddZipCodeModalTypes {
  show: boolean,
  setOpenFrom: () => void,
}
export interface AddZipCodeFields {
  zipCode: string | undefined,
  stateCode: string | undefined,
  cityCode: string | undefined,
  countryCode: string | undefined,
}
export enum AddZipCodeFieldsEnum {
  zipCode = 'zipCode',
  stateCode = 'stateCode',
  cityCode = 'cityCode',
  countryCode = 'countryCode',
}
export const ZipCodeTableColumns = [
  // { key: 'sn', label: 'SN' },
  // { key: 'action', label: 'Action' },
  { key: 'countryCode', label: 'Country' },
  { key: 'pinCode', label: 'Zip' },
  { key: 'stateCode', label: 'State Code' },
  { key: 'cityName', label: 'City' },
];
export interface ZipCodeListingInterface {
  countryCode: string;
  zipCode: string;
  stateCode: string;
  cityCode: string;
}
